import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentosProjetoService } from '../services/documentos-projeto.service';
import { PermissionProjectService } from '../services/permission.project.service';
import { PesquisaGeralService } from '../services/pesquisa-geral.service';
import { ProjetoCadastroService } from '../services/projeto-cadastro.service';

@Injectable({
  providedIn: 'root'
})
export class InfoProjetoResolver implements Resolve<boolean> {

  constructor(private service: PesquisaGeralService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.infoProjeto(route.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CadastroProjectResolver implements Resolve<boolean> {

  constructor(private service: ProjetoCadastroService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class InfoProjetoStorageResolver implements Resolve<boolean> {

  constructor(private service: PesquisaGeralService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.infoProjeto(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class DocumentosProjetoResolver implements Resolve<boolean> {

  constructor(private service: DocumentosProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectPermissionResolver implements Resolve<boolean> {

  constructor(private service: PermissionProjectService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getPermission(route.params.idProjeto);
  }
}

